import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import {
  LOCATION_ALL_COOKIE_VALUE,
  LOCATION_ID_COOKIE,
  LOCATION_ID_COOKIE_CHANGE_EVENT,
} from '../../constants/LocationCookie';

export const useLocationIdCookie = () => {
  const [cookieId, setCookieId] = useState(() => Cookies.get(LOCATION_ID_COOKIE));

  useEffect(() => {
    const syncCookieId = () => setCookieId(Cookies.get(LOCATION_ID_COOKIE));
    syncCookieId();
    window.addEventListener(LOCATION_ID_COOKIE_CHANGE_EVENT, syncCookieId);
    return () => window.removeEventListener(LOCATION_ID_COOKIE_CHANGE_EVENT, syncCookieId);
  }, []);

  return cookieId;
};

export const useIsAllLocationsSelected = () =>
  useLocationIdCookie() === LOCATION_ALL_COOKIE_VALUE;

export default useLocationIdCookie;
